import { render, staticRenderFns } from "./ReportesLectorCodigo.vue?vue&type=template&id=2643608e&"
import script from "./ReportesLectorCodigo.vue?vue&type=script&lang=js&"
export * from "./ReportesLectorCodigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports